import styled from 'styled-components';
import { white, primary } from 'styles/colorProvider';

export const Container = styled.div`
  background-color: ${white};
  width: 100%;
  height: 100% !important;
  max-height: 100% !important;
  overflow-y: hidden !important;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const ContentArea = styled.div`
  display: flex;
  align-items: left;
  flex-direction: column;
  width: 90%;
  height: 100% !important;
  max-height: 100% !important;
  box-sizing: border-box;
  padding: 30px;
  padding-left: 90px;
  position: relative;

  .toolbar {
    background-color: #f9fcff;
    display: flex;
    flex-direction: row;
    padding: 0 10px;
    justify-content: flex-end;
    align-items: center;
    border-radius: 5px;
    margin: 5px 0px;

    @media (max-width: 550px) {
      flex-direction: column;
    }
  }

  @media (max-width: 1000px) {
    width: 100%;
    padding-left: 20px;
  }
`;

export const Title = styled.h1`
  font-size: 28px;
  color: ${primary};
  margin-bottom: 10px;

  @media (max-width: 1000px) {
    margin: 20px 0px;
  }
`;

export const Div = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  .containerTitle {
    display: flex;
    width: 40%;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;

    @media (max-width: 1000px) {
      width: 100%;
    }
  }

  @media (max-width: 1000px) {
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
`;

export const DataArea = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  height: 65vh !important;
  max-height: 65vh !important;
  overflow: auto;
  overflow-x: auto;
  box-sizing: border-box;
  padding: 10px;
  min-width: 0;

  &::-webkit-scrollbar {
    width: 5px;
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${primary};
    border-radius: 10px;
  }

  @media (max-width: 1000px) {
    margin-top: 20px;
    padding: 20px;
  }
`;

export const ListHeader = styled.div`
  width: 100%;
  min-width: min(100%, 960px);
  display: grid;
  grid-template-columns: 44px minmax(100px, 1.2fr) minmax(90px, 1fr) 90px minmax(80px, 0.9fr) minmax(100px, 1.4fr) 110px 100px 44px 52px 72px;
  gap: 12px 16px;
  align-items: center;
  padding: 8px 16px 10px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: ${primary};
  border-bottom: 2px solid rgba(0, 0, 0, 0.08);
  margin-top: 4px;
  box-sizing: border-box;

  @media (max-width: 1200px) {
    grid-template-columns: 40px minmax(90px, 1fr) minmax(80px, 0.9fr) 80px minmax(70px, 0.8fr) minmax(90px, 1.2fr) 100px 90px 40px 44px 64px;
    gap: 10px 12px;
    padding: 8px 12px;
  }

  @media (max-width: 900px) {
    display: none;
  }
`;

export const LoadingArea = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding-top: 100px;
`;
export const ModalButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: right;
  align-items: center;
  width: 100%;

  @media (max-width: 1000px) {
    justify-content: center;
    flex-direction: column;
  }
`;

export const CountArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  font-size: 12px;

  p {
    margin: 0px;
  }
`;
